import type { SetQuery } from 'use-query-params/lib/types';

import type { OVERLAY_MODAL } from 'src/constants/modals';

import {
  BUCKET_QUERY_PARAM_KEY,
  NAVIGATION_QUERY_PARAM_KEY,
  OVERLAY_QUERY_PARAM_KEY,
  PAGE_QUERY_PARAM_KEY,
  SEARCH_QUERY_PARAM_KEY,
  REFERRER_QUERY_PARAM_KEY,
} from '../../pages/CandidateManagementPage/queryParams';
import { getQueryFromBucket } from '../../pages/CandidateManagementPage/utils/BucketQueryParam';
import type { Bucket } from '../../stores/JobApplicationStore/types';
import { SUPPORT_BACK_BUTTON } from '../buildHandleEnterAndSpaceKeyPress';

import type { QueryParamConfigMapType } from './types';

class SetQueryParams {
  private readonly setQuery: SetQuery<QueryParamConfigMapType>;

  constructor(setQuery: SetQuery<QueryParamConfigMapType>) {
    this.setQuery = setQuery;
  }

  updatePage(page: number | undefined) {
    this.setQuery({ [PAGE_QUERY_PARAM_KEY]: page }, SUPPORT_BACK_BUTTON);
  }

  clearReferrer() {
    this.setQuery(
      { [REFERRER_QUERY_PARAM_KEY]: undefined },
      SUPPORT_BACK_BUTTON,
    );
  }

  navigateToSearch(searchText: string) {
    this.setQuery(
      {
        [PAGE_QUERY_PARAM_KEY]: undefined,
        [BUCKET_QUERY_PARAM_KEY]: undefined,
        [NAVIGATION_QUERY_PARAM_KEY]: undefined,
        [SEARCH_QUERY_PARAM_KEY]: searchText,
      },
      SUPPORT_BACK_BUTTON,
    );
  }

  navigateToBucket(bucket: Bucket) {
    this.setQuery(
      {
        [PAGE_QUERY_PARAM_KEY]: undefined,
        [BUCKET_QUERY_PARAM_KEY]: getQueryFromBucket(bucket),
        [SEARCH_QUERY_PARAM_KEY]: undefined,
        [NAVIGATION_QUERY_PARAM_KEY]: undefined,
      },
      SUPPORT_BACK_BUTTON,
    );
  }

  displayOverlayModal(overlay: OVERLAY_MODAL) {
    this.setQuery(
      {
        [OVERLAY_QUERY_PARAM_KEY]: overlay,
      },
      SUPPORT_BACK_BUTTON,
    );
  }

  clearOverlayModal() {
    this.setQuery(
      {
        [OVERLAY_QUERY_PARAM_KEY]: undefined,
      },
      SUPPORT_BACK_BUTTON,
    );
  }
}

export default SetQueryParams;
